





















import { defineComponent, PropType } from '@nuxtjs/composition-api';
import BenefitsBladeContainer from './ui/BenefitsBladeContainer.vue';
import BenefitsBladeHeadline from './ui/BenefitsBladeHeadline.vue';
import { IComplianceList } from './index';
import BenefitsBladeTitle from './ui/BenefitsBladeTitle.vue';
import BenefitsBladeDescription from './ui/BenefitsBladeDescription.vue';
import BenefitsBladeComplianceList from './ui/BenefitsBladeComplianceList.vue';

export default defineComponent({
  name: 'BaseBenefitsBlade',
  components: {
    BenefitsBladeContainer,
    BenefitsBladeHeadline,
    BenefitsBladeTitle,
    BenefitsBladeDescription,
    BenefitsBladeComplianceList,
  },
  props: {
    headline: {
      type: String as PropType<string>,
      default: 'Want to learn more about Bambee?',
    },
    title: {
      type: String as PropType<string>,
      default: 'Save on compliance and manage your risks',
    },
    description: {
      type: String as PropType<string>,
      default:
        'Compliance problems can be costly – and they can also be avoided with a strong HR management software that addresses employee training, compliance support and readily-available HR management on demand. Introducing: Bambee. ',
    },
    complianceList: {
      type: [] as PropType<IComplianceList[]>,
    },
  },
});
